import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "@app/directives/shared.module";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { WarningModule } from '@app/modals/warning/warning.module'
import { c_dtable_app_users_list_component } from "./c_dtable_app_users_list_component"

@NgModule({
  imports: [CommonModule, FormsModule, SharedModule, MatCheckboxModule, WarningModule],
  declarations: [c_dtable_app_users_list_component],
  exports: [c_dtable_app_users_list_component],
})
export class c_dtable_app_users_list_module {}
